import { Button } from "@fluentui/react-components";
import { ArrowClockwiseRegular } from "@fluentui/react-icons";
import { useInvalidateBenefitImplementationPackages } from "state/queries/useGetBenefitImplementationPackages";

export function PackagesRefreshBtn() {
  const invalidateBenefitImplementationPackages =
    useInvalidateBenefitImplementationPackages();

  const handleRefresh = () => {
    invalidateBenefitImplementationPackages();
  };

  return (
    <Button
      data-help="packages-refresh"
      onClick={handleRefresh}
      appearance="outline"
      icon={<ArrowClockwiseRegular />}
    />
  );
}
